module.exports = __webpack_public_path__ + "img/bg-cintillo-promotion.343d43cb.png";